import type { AdminTeacherVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTeacher = createApiThunk<AdminTeacherVM, string>(
  "teachers/retrieveTeacher",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getTeacher(id);
  },
);
